import { createSelector } from 'reselect';
import { RefObject } from 'react';

interface ListProps {
  data: unknown[];
  renderItem: (item: unknown, index: number, ref?: RefObject<HTMLElement>) => React.ReactNode;
}

interface ListState {
  startIndex: number;
  endIndex: number;
}

export const selectItems = createSelector(
  (props: ListProps) => props.data,
  (_: ListProps, state: ListState) => state.startIndex,
  (_: ListProps, state: ListState) => state.endIndex,
  (props: ListProps) => props.renderItem,
  (_: ListProps, __: ListState, ref: RefObject<HTMLElement> | undefined) => ref,
  (data, startIndex, endIndex, renderItem, ref) => {
    return data
      .slice(startIndex, endIndex + 1)
      .map((item, index) =>
        renderItem(item, index + startIndex, index === 0 ? ref : undefined),
      );
  },
);
